import $ from 'jquery';

const SiteHeader = () => {
    const $siteHeader = $('.siteHeader');

    const init = () => {
        if (!$siteHeader.length) {
            return;
        }

        let prevScrollTop = 0;
        $(window).on('scroll load', () => {
            const scrollTop = $(window).scrollTop();
            $siteHeader.toggleClass('sticky', scrollTop > 0);
            $siteHeader.toggleClass('hidden', window.innerWidth > 1024 && scrollTop > prevScrollTop);
            prevScrollTop = scrollTop;
        });
    }

    const hide = () => {
        $siteHeader.addClass('hidden');
    }

    const show = () => {
        $siteHeader.removeClass('hidden');
    }

    return Object.freeze({ init, hide, show });
};

export default SiteHeader;